module.exports = __webpack_public_path__ + "img/B250.ad789bd6.png";